import {CardActionsRepository} from "@/modules/cardActions/adapter/CardActionsRepository";
import {BranchOrderRepository} from "@/modules/branchOrder/adapter/BranchOrderRepository";

export class BranchOrderPort implements BranchOrderRepository{
    private readonly branchOrderRepository: BranchOrderRepository;

    constructor(params: { branchOrderRepository: BranchOrderRepository }) {
        this.branchOrderRepository = params.branchOrderRepository;
    }
    public async sendOrder(value:any):Promise<string>{
        return this.branchOrderRepository.sendOrder(value);
    }
    public async sendB2BOrder(value:any):Promise<string>{
        return this.branchOrderRepository.sendB2BOrder(value);
    }
    public async printOrder(value:any, printall:boolean):Promise<string> {
        return this.branchOrderRepository.printOrder(value,printall);
    }

}
